import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../../../services/main/api.service';
import { LoginService } from '../../../../services/authentication/login.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../../services/global';
import { BaseCrudComponent } from '../../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';

import { Observable, from, of, concat } from 'rxjs';
import { mergeMap, catchError, timeout, retry, debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { AgmBicyclingLayer, MapsAPILoader } from '@agm/core';

declare const google: any;

@Component({
  selector: 'app-routes',
  templateUrl: './routes.component.html',
  styleUrls: ['./routes.component.css']
})
export class RoutesComponent extends BaseCrudComponent {

  	translations:any;
    orders:any;
    ordersPending:any;
    drivers:any;
    trucks:any;
    loadingRequired:any;
    

    lat: number = -2.191332;
    lng: number = -79.565221;
    zoom: number = 10;
    //ubicacion por defecto de la persona
    customers:any;
    selectedCreate:any;
    hivi_coords:any;
    hivi_win:any;
    loadingORdefaults = false;
    processingOR = false;
    googleLoaded = false;
    avgSpeed = 13.8;//meters by secs (50 km/h)

    public branches:any;
    public usr_subsidiary:any;

    branch_obj:any;
    customers_num:any;
    branch_marker = Global.branch_marker;

  	constructor(
        srv: ApiService,
        modalService: NgbModal,
        storage: Storage,
        router: Router,
        private route: ActivatedRoute,
        public translate: TranslateService,
        private fb: FormBuilder,
        public mapsAPILoader: MapsAPILoader,
        private login: LoginService
      ) {
        super(srv, modalService, storage, router);

        this.read_url = 'LogisticRoute/All';
        this.create_url = 'LogisticRoute/Create';
        this.update_url = 'LogisticRoute/Update';
        this.delete_url = 'LogisticRoute/LogicalDelete';
        this.search_fields = ['name', 'driver', 'status'];
        this.loadingRequired = false;
        this.selectedCreate = [];

        this.reload.subscribe(val => {
            if( val ){
                super.clearData();
                this.getList();
            }
        });

        this.ordersPending=null;
        this.orders=null;
        this.rows =null;

        this.srv.getCall("LogisticDriver/All").subscribe(x => {
            var data = x.data;
            
            this.loadingList=false;
            if(x.status){
                this.drivers = x.data;//todos los drivers
            }
        }),
        catchError(x => {return of(false)})


        this.customers = [];

        this.regularForm = this.fb.group({
            checkArray: this.fb.array([])
        });

        this.trucks = [];
        this.getVehiclesData().subscribe(t => {
            if( t != false ){
                this.trucks = t;
            }
        });

        this.branches = [];
        this.usr_subsidiary = -1;
    }

    HiviLogisticRoutexdestinations = [];
    destinationId={};
    onCheckboxChange(e,id){
        const checkArray: FormArray = this.regularForm.get('checkArray') as FormArray;
        if (e.target.checked) {
            checkArray.push(new FormControl(e.target.value));
            this.destinationId={
                'destinationId':id
            }
            this.HiviLogisticRoutexdestinations.push(this.destinationId);
        } else {
            let i: number = 0;
            checkArray.controls.forEach((item: FormControl) => {
                if (item.value == e.target.value) {
                    checkArray.removeAt(i);
                    this.HiviLogisticRoutexdestinations.splice(i, 1);
                    return;
                }
                i++;
            });
        }
    }

    ngOnInit() {
        this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
            this.translations = translations;
            super.ngOnInit();
            this.getList();

            this.getBranchesData().subscribe(b => {
                this.loadingRequired = false;
                if( b != false ){
                    this.branches = b;
                }
            });

            this.login.getTeam().then(t => {
                if( (t == undefined) || (t == null) ){
                    t = 0;
                }
                
                this.usr_subsidiary = t;
            });
        });

        this.hivi_coords = null;
        this.hivi_win = null;
        this.loadingORdefaults = true;

        this.mapsAPILoader.load().then((g) => {
            this.googleLoaded = true;

            this.getORdefaults().subscribe(x => {
                this.loadingORdefaults = false;
                
                if( x != false ){
                    let coords = x.hiviCoordinates.replace(/\s/g, '').split(',');
                    this.hivi_coords = {lat: coords[0], lng: coords[1]};

                    let wins = x.windowsTimeDefault.replace(/\s/g, '').split(',');
                    this.hivi_win = {from: wins[0], to: wins[1]};
                }
            });
        });

    }

    getList(){
        var qst = this.read_url;
        this.clearData();
        this.loadingList=true;
        this.srv.getCall(qst).subscribe(x => {
            var data = x.data;
            this.loadingList=false;
            if(x.status){
                this.rawdata = x.data;
                this.rows = x.data;

                this.page = 1;

                if( Array.isArray(this.rows) ){
                    this.pageTotal = this.rows.length;
                }
            }
        }),
        catchError(x => {return of(false)})
        this.rows =null;
    }

    public getFiltersData(){
        var par_url = 'Profile/All';
        return  this.srv.getCall(par_url).pipe(
                    mergeMap(x => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = x;
                        if(mydata.status == true ){
                          return of(mydata.data);
                        }else{
                          return of(false);
                        }
                    }),
                    //timeout(MAX_TIME),
                    catchError(data => of(false))
                );
    }

    public getVehiclesData(){
        var par_url = 'LogisticTruck/All';
        return  this.srv.getCall(par_url).pipe(
                    mergeMap(x => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = x;
                        if(mydata.status == true ){
                          return of(mydata.data);
                        }else{
                          return of(false);
                        }
                    }),
                    //timeout(MAX_TIME),
                    catchError(data => of(false))
                );
    }

    public getORdefaults(){
        var par_url = 'LogisticRoute/OptimalRoutParameter';
        return  this.srv.getCall(par_url).pipe(
                    mergeMap(x => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = x;
                        if(mydata.status == true ){
                          return of(mydata.data);
                        }else{
                          return of(false);
                        }
                    }),
                    //timeout(MAX_TIME),
                    catchError(data => of(false))
                );
    }

    openCreateModal(content:any){
        this.c_obj = {};
        super.openCreateModalLG(content);

        //this.srv.getCall("LogisticDestination/All").subscribe(x => {
        this.srv.getCall("LogisticDestination/AllPending").subscribe(x => {
            var data = x.data;
            
            this.loadingList = false;
            if(x.status){
                this.orders = x.data;
            }
            
        }),
        catchError(x => {return of(false)})
    }

    openUpdateModal(content:any, obj:any){
        obj.permList = [];
        this.u_obj = obj;
        this.orders = this.u_obj.destinations;
        console.log(this.u_obj);//return;

        this.srv.getCall("LogisticDestination/AllPending").subscribe(x => {
            var data = x.data;
            this.loadingList = false;

            if(x.status){
                this.ordersPending = x.data;//los pendientes
            }
        });

        super.openCreateModalLG(content);
    }

    deleteRow(id){
        for(let i = 0; i < this.orders.length; ++i){
            if (this.orders[i].destination.id === id) {
                this.ordersPending.push(this.orders[i].destination);
                this.orders.splice(i,1);
            }
        }
    }

    addDestination(id){
        for(let i = 0; i < this.ordersPending.length; ++i){
            if (this.ordersPending[i].id === id) {
                this.orders.push({
                    "destination": {
                        'package':this.ordersPending[i].package,
                        'routeSap':this.ordersPending[i].routeSap,
                        'quantity':this.ordersPending[i].quantity,
                        'guideNumber':this.ordersPending[i].guideNumber,
                        'weight':this.ordersPending[i].weight,
                        'invoiceNumber':this.ordersPending[i].invoiceNumber,
                        'clientName':this.ordersPending[i].clientName,
                        'province':this.ordersPending[i].province,
                        'recipientCity':this.ordersPending[i].recipientCity
                    }
                })
                this.ordersPending.splice(i,1);
            }
        }
    }

    validateCreateInfo(fields:any){
        let mygroup:any = {};
        mygroup = new FormGroup({
            'name': new FormControl(fields.name, [Validators.required]),
            'description': new FormControl(fields.description, [Validators.required]),
            'driverId': new FormControl(fields.driverId, [Validators.required]),
            'truckId': new FormControl(fields.truckId, [Validators.required])

        });

        return mygroup.valid;
    }

    openMapModal(content:any, obj:any){
        this.u_obj = obj;
        super.openCreateModalLG(content);
        this.customers = [];
        this.customers_num = [];
        //console.log(obj);
        
        obj.destinations.forEach(element => {
            var latlng: string;
            latlng = element.destination.coordinate.split(";");
            //latlng = element.coordinate.split(";");
            this.customers.push({name:element.destination.clientName, lat:latlng[0], lng:latlng[1]});
            //this.customers.push({name:element.clientName, lat:latlng[0], lng:latlng[1]});
            this.customers_num.push({lat:parseFloat(latlng[0]), lng:parseFloat(latlng[1])});
        });

        this.branch_obj = {};
        
        if( obj.subsidiaryLocation != undefined ){
            var coord: string;
            coord = obj.subsidiaryLocation.location.split(",");

            this.branch_obj.lat = coord[0];
            this.branch_obj.lng = coord[1];
            this.branch_obj.name = obj.subsidiaryLocation.name;
            this.customers_num.unshift({lat:parseFloat(coord[0]), lng:parseFloat(coord[1])});
        }
    }

    public createItem(content:any, form:any){
        var validated = true;

        if( form == undefined ){
          form = {};
        }

        validated = this.validateCreateInfo(form);
        if( !validated ){
            Swal.fire(this.translations['msg_all_required'], '', 'error');
            return;
        }

        if( this.usr_subsidiary == 0 ){
            if( (form['subsidiaryId'] == undefined) || (form['subsidiaryId'] == null) ){
                Swal.fire('Debe seleccionar sucursal', '', 'error');
                return;
            }
        }
        else{
            form['subsidiaryId'] = null;
        }

        if( this.selectedCreate.length <= 0 ){
            Swal.fire('No hay destinos seleccionados', '', 'error');
            return;
        }

        var to:any;
        to = this.buildJSONStructure(form);

        let details = [];

        //reorder selected ones due to manual sort of base array does not refresh selected
        var sel_ids = [];
        this.selectedCreate.forEach(s => {
            sel_ids.push(s.id);
        });

        let i = 1;
        /*this.selectedCreate.forEach(s => {
            details.push({'destinationId': s.id, 'position': i});
            i++;
        });*/
        this.orders.forEach(o => {
            if( sel_ids.indexOf(o.id) >= 0 ){
                details.push({'destinationId': o.id, 'position': i});
                i++;
            }
        });

        /*console.log(this.selectedCreate);
        console.log(details);
        return;*/

        to['HiviLogisticRoutexdestinations'] = details;
        
        var qst = this.create_url;
        this.isCreating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isCreating = false;
            //console.log(x);
            if(x.status){
                this.c_obj = {};
                this.getList();
                //this.HiviLogisticRoutexdestinations = [];
                this.closeModal(content);
                Swal.fire('Creado', '', 'success');
            }//end success
            else{
                //Swal.fire(this.translations[x.msg], '', 'error');
                Swal.fire(x.message, '', 'error');
                //Swal.fire("entro", '', 'success');
            }
        });
    }


    public updateItem(content:any, form:any){
        var validated = true;

        if( form == undefined ){
          form = {};
        }

        validated = this.validateCreateInfo(form);
        if( !validated ){
            Swal.fire(this.translations['msg_all_required'], '', 'error');
            return;
        }

        if( this.usr_subsidiary == 0 ){
            if( (form['subsidiaryId'] == undefined) || (form['subsidiaryId'] == null) ){
                Swal.fire('Debe seleccionar sucursal', '', 'error');
                return;
            }
        }
        else{
            form['subsidiaryId'] = null;
        }

        var to:any;
        this.HiviLogisticRoutexdestinations = [];
        this.readSelectedOrders();
        to = this.buildJSONStructure(form);
        to.id = form.id;
        to.HiviLogisticRoutexdestinations = this.HiviLogisticRoutexdestinations;

        var qst = this.update_url;
        this.isUpdating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isUpdating = false;
            if(x.status){
                this.getList();
                this.closeModal(content);
                Swal.fire(this.translations['updated'], '', 'success');
            }//end success
            else{
                Swal.fire(x.message, '', 'error');
              //this.closeModal(content);
            }
        });
    }

    formAndTableData: {};
    buildJSONStructure(form){
        return this.formAndTableData = {
            'name': form.name,
            'description': form.description,
            'driverId': form.driverId,
            'truckId': form.truckId,
            'subsidiaryId': form.subsidiaryId,
            'HiviLogisticRoutexdestinations': []
            //'HiviLogisticRoutexdestinations':this.HiviLogisticRoutexdestinations
        };

    }

    readSelectedOrders(){
        for(let i = 0; i < this.orders.length; ++i){
            this.HiviLogisticRoutexdestinations.push({
                'destinationId':this.orders[i].destination.id,
                'position': i + 1
            });
        }
    }

    calculateTimeTo(p1:any, p2:any){
        //distance in meters
        let dist = google.maps.geometry.spherical.computeDistanceBetween(p1, p2);
        //calculate time based in formula: speed = distance / time
        let tto = Math.round(dist / this.avgSpeed);
        return tto;
    }

    calculateOR(){
        let items = [];
        let time_matrix = [];
        let windows = [];
        let ids = [];
        let tmp_orders = [];
        //let tmp_selected = [];
        let errors = [];

        items.push({
            id: 0,
            coord_obj: new google.maps.LatLng(this.hivi_coords.lat, this.hivi_coords.lng),
            tw: [this.hivi_win.from, this.hivi_win.to]
        });

        this.selectedCreate.forEach(x => {
            if( (x.coordinate != null) && (x.coordinate != '') ){
                let coords = x.coordinate.replace(/\s/g, '').split(';');

                if( isNaN(coords[0]) || isNaN(coords[1]) ){
                    errors.push(x);
                }
                else{
                    items.push({
                        id: x.id,
                        coord_obj: new google.maps.LatLng(coords[0], coords[1]),
                        tw: [this.hivi_win.from, this.hivi_win.to]
                    });
                }
            }
        });

        if( errors.length > 0 ){
            let eitems = '';
            errors.forEach(e => {
                eitems += e.deliveryNumber + ' | ';
            });
            
            Swal.fire('Varios elementos seleccionados tienen coordenadas inválidas: ' + eitems, '', 'error');
            return;
        }

        if( items.length < 2 ){
            Swal.fire('No hay elementos para ordenar', '', 'error');
            return;
        }

        let row = [];
        items.forEach(i => {
            row = [];

            items.forEach(j => {
                row.push(this.calculateTimeTo(i.coord_obj, j.coord_obj));
            });

            time_matrix.push(row);
            windows.push(i.tw);
            ids.push(i.id);
        });

        console.log(items);
        console.log(time_matrix);
        console.log(windows);
        console.log(ids);

        var qst = 'LogisticRoute/GetOptimalRoute';
        var tosend = {
            ids: ids,
            timeMatrix: time_matrix,
            timeWindows: windows
        };

        this.processingOR = true;

        this.srv.postCall(qst, tosend).subscribe(x => {
            this.processingOR = false;
            if(x.status){
                //console.log(x);
                let new_ids = x.data;

                if( Array.isArray(new_ids) && (new_ids.length > 0) ){
                    //add processed
                    new_ids.forEach(id => {
                        if( id != 0 ){
                            let tmp = this.orders.filter(f => {return f.id == id})[0];
                            tmp_orders.push(tmp);
                            //tmp_selected.push(tmp);
                        }
                    });

                    //replace selected ones
                    //this.selectedCreate = tmp_selected;

                    //add others
                    this.orders.forEach(o => {
                        if( new_ids.indexOf(o.id) < 0 ){
                            tmp_orders.push(o);
                        }
                    });

                    //console.log(tmp_orders);
                    this.orders = tmp_orders;
                }
                else{
                    Swal.fire('No fue posible generar', '', 'error');
                }
                
                Swal.fire('Ruta óptima generada exitosamente', '', 'success');
            }//end success
            else{
                Swal.fire(x.message, '', 'error');
            }
        });
    }

    public getBranchesData(){
        var par_url = 'Subsidiary/All';
        return this.srv.getCall(par_url).pipe(
                    mergeMap(x => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = x;
                        
                        if(mydata.status == true ){
                          return of(mydata.data);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => of(false))
                );
    }

}
